import { doNothing } from 'remeda';
import { create } from 'zustand';

export interface ConfirmOptions {
  title: string;
  body: string;
  confirmLabel: string;
  cancelLabel?: string;
  danger?: boolean;
}

export interface AlertOptions {
  title: string;
  body: string;
  acknowledgeLabel: string;
}

export type ConfirmationRequest =
  | ({ kind: 'confirm' } & ConfirmOptions)
  | ({ kind: 'alert' } & AlertOptions);

type Resolver = (value: boolean) => void;

interface ConfirmationModalState {
  isOpen: boolean;
  request: ConfirmationRequest | null;
  resolve: Resolver;
  openConfirmation: (request: ConfirmationRequest, resolve: Resolver) => void;
  settleConfirmation: (value: boolean) => void;
}

export const useConfirmationStore = create<ConfirmationModalState>((set, get) => ({
  isOpen: false,
  request: null,
  resolve: doNothing,

  openConfirmation: (request, resolve) => set({ isOpen: true, request, resolve }),
  settleConfirmation: (value) => {
    get().resolve(value);
    set({ isOpen: false, resolve: doNothing });
  },
}));
